module.exports = __webpack_public_path__ + "c780b32045b5b0d8f1129d5de64398f9.svg";